export function getHighestSafeWindowContext(self = window.self): any {
  if (self === window.top) {
    return self;
  }

  if (!isCrossOriginFrame()) {
    return getHighestSafeWindowContext(self.parent);
  }

  return self;
}

const isCrossOriginFrame = () => {
  try {
    return (
        window.location.hostname !== window.parent.location.hostname
    );
  } catch (e) {
    return true;
  }
};

export function getWindowWidth() {
  return typeof window !== 'undefined' ? window.innerWidth : 0;
}

export function getWindowHeight() {
  return typeof window !== 'undefined' ? window.innerHeight : 0;
}
